import QRCode from 'qrcode';

/**
 * QR code como SVG inline.
 *
 * SVG e não PNG porque o QR é exibido ENORME numa TV: precisa ficar nítido em
 * 1920×1080 sem gerar um bitmap gigante. `errorCorrectionLevel: 'M'` dá
 * tolerância suficiente para leitura de dois metros de distância, com a câmera
 * tremendo na mão.
 */
export async function qrSvg(text: string): Promise<string> {
  return QRCode.toString(text, {
    type: 'svg',
    errorCorrectionLevel: 'M',
    margin: 1,
    color: { dark: '#17142e', light: '#ffffff' },
  });
}
